// Reusable JSON-LD schema builders for WPAA pages.
// All schemas align with schema.org and Google's structured data guidelines.

const SITE = 'https://wpaauae.com';
const ORG_NAME = 'White Paper Accounts Auditing';
const ORG_LEGAL = 'White Paper Audit | Tax | Advisory';
const PHONE = '+971-50-121-9341';
const PHONE_OFFICE = '+971-6-744-7940';
const EMAIL = 'info@wpaauae.com';
const ADDRESS_STREET = '109, Midaffa Bldg., Musab Bin Omair St., Al Mahatta';
const ADDRESS_CITY = 'Sharjah';
const ADDRESS_COUNTRY = 'AE';

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, idx) => ({
    '@type': 'ListItem',
    position: idx + 1,
    name: item.name,
    item: `${SITE}${item.path}`
  }))
});

export const serviceSchema = ({ name, description, path, serviceType }) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: serviceType || name,
  name,
  description,
  url: `${SITE}${path}`,
  provider: {
    '@type': 'AccountingService',
    name: ORG_NAME,
    url: SITE,
    telephone: PHONE,
    email: EMAIL,
    address: {
      '@type': 'PostalAddress',
      streetAddress: ADDRESS_STREET,
      addressLocality: ADDRESS_CITY,
      addressCountry: ADDRESS_COUNTRY
    }
  },
  areaServed: {
    '@type': 'Country',
    name: 'United Arab Emirates'
  }
});

export const faqSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: a
    }
  }))
});

export const aboutPageSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  url: `${SITE}/about`,
  mainEntity: {
    '@type': 'Organization',
    name: ORG_NAME,
    legalName: ORG_LEGAL,
    url: SITE,
    foundingDate: '2025',
    description:
      'UAE-based audit, tax, and advisory firm providing comprehensive financial services to businesses across Mainland and Free Zones.'
  }
});

export const contactPageSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  url: `${SITE}/contact`,
  mainEntity: {
    '@type': 'Organization',
    name: ORG_NAME,
    telephone: PHONE,
    email: EMAIL,
    address: {
      '@type': 'PostalAddress',
      streetAddress: ADDRESS_STREET,
      addressLocality: ADDRESS_CITY,
      addressCountry: ADDRESS_COUNTRY
    },
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: PHONE,
        contactType: 'customer service',
        email: EMAIL,
        areaServed: 'AE',
        availableLanguage: ['English', 'Arabic']
      },
      {
        '@type': 'ContactPoint',
        telephone: PHONE_OFFICE,
        contactType: 'customer service',
        areaServed: 'AE',
        availableLanguage: ['English', 'Arabic']
      }
    ]
  }
});
